module.exports = __webpack_public_path__ + "static/media/aauxnext-rgit.8d9304f6.woff2";